export default "__VITE_ASSET__7e3f5e7c__"